var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndsStuff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E80400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 8.33332L19.1334 8.57498L17.4167 14.75L10.1667 7.49998H12.5L10 3.94998L8.60004 5.93332L7.40837 4.74165L9.31671 2.02498C9.46671 1.80832 9.71671 1.66665 10 1.66665C10.2834 1.66665 10.5417 1.80832 10.6917 2.03332L14.5167 7.49998H18.3334C18.7917 7.49998 19.1667 7.87498 19.1667 8.33332ZM18.425 17.8833L17.3667 18.9416L15.8584 17.4333C15.7167 17.475 15.5667 17.5 15.4167 17.5H4.58337C3.93337 17.5 3.36671 17.125 3.09171 16.5833L0.916707 8.69998L0.833374 8.33332C0.833374 7.87498 1.20837 7.49998 1.66671 7.49998H5.48337L5.66671 7.24165L0.925041 2.49998L1.99171 1.44165L18.425 17.8833ZM11.5417 13.1166L9.38337 10.9583C8.75004 11.2 8.33337 11.8 8.33337 12.5C8.33337 13.425 9.08337 14.1666 10 14.1666C10.7 14.1666 11.3 13.75 11.5417 13.1166Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndsStuff);
export default __webpack_public_path__ + "static/media/ends-stuff.242b93dc46a5292b0605bca5a1fada7d.svg";
export { ForwardRef as ReactComponent };